var _rect, _polygon, _g, _polygon2, _polygon3, _g2, _polygon4, _g3, _polygon5, _polygon6, _g4, _polygon7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 85.333,
    fill: "#FFFFFF",
    width: 512,
    height: 341.337
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D80027",
    points: "288,85.33 224,85.33 224,223.996 0,223.996 0,287.996 224,287.996 224,426.662 288,426.662   288,287.996 512,287.996 512,223.996 288,223.996 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "393.785,315.358 512,381.034 512,315.358  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "311.652,315.358 512,426.662 512,395.188 368.307,315.358  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "458.634,426.662 311.652,344.998 311.652,426.662  "
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "311.652,315.358 512,426.662 512,395.188 368.307,315.358 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D80027",
    points: "311.652,315.358 512,426.662 512,395.188 368.307,315.358 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "90.341,315.356 0,365.546 0,315.356  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "200.348,329.51 200.348,426.661 25.491,426.661  "
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D80027",
    points: "143.693,315.358 0,395.188 0,426.662 0,426.662 200.348,315.358 "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "118.215,196.634 0,130.958 0,196.634  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "200.348,196.634 0,85.33 0,116.804 143.693,196.634  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "53.366,85.33 200.348,166.994 200.348,85.33  "
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "200.348,196.634 0,85.33 0,116.804 143.693,196.634 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D80027",
    points: "200.348,196.634 0,85.33 0,116.804 143.693,196.634 "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "421.659,196.636 512,146.446 512,196.636  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0052B4",
    points: "311.652,182.482 311.652,85.331 486.509,85.331  "
  }))), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D80027",
    points: "368.307,196.634 512,116.804 512,85.33 512,85.33 311.652,196.634 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.562cf2c8d2e3fbce8c313a109f6aa594.svg";
export { ForwardRef as ReactComponent };